import React, { useRef, useEffect } from 'react';
import { useGame } from '../../context/GameContext';
import './TurnManagement.css';

const WordDescription = () => {
  const { 
    gameState, 
    isMyTurn, 
    assignedWord,
    dictionary,
    descriptionInput,
    setDescriptionInput,
    validationError,
    handleSubmitDescription
  } = useGame();

  const descriptionInputRef = useRef(null);

  // Focus the description input when the component mounts and when isMyTurn changes
  useEffect(() => {
    if (isMyTurn && descriptionInputRef.current && gameState === 'describing') {
      descriptionInputRef.current.focus();
    }
  }, [isMyTurn, gameState]);

  // Only show this component when game state is describing
  if (gameState !== 'describing') {
    return null;
  }

  // Only the active player can describe a word
  if (!isMyTurn) {
    return (
      <div className="turn-management-section">
        <div className="waiting-for-turn-section">
          <h3>Waiting for Word Description</h3>
          <p className="waiting-text">The active player is creating a description...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="turn-management-section">
      <div className="describing-section">
        <h3>Describe This Word</h3>
        <div className="assigned-word-display">
          <p>Your word is:</p>
          <div className="assigned-word">{assignedWord}</div>
        </div>
        <p className="instruction-text">
          Describe this word using ONLY words from the dictionary. Click on words to add them to your description.
        </p>
        
        <div className="description-builder">
          <div className="selected-words-container">
            {descriptionInput.split(' ').filter(word => word.trim()).map((word, index) => (
              <div key={index} className="selected-word-card">
                {word}
                <button 
                  className="remove-word-btn" 
                  onClick={() => {
                    const words = descriptionInput.split(' ').filter(w => w.trim());
                    words.splice(index, 1);
                    setDescriptionInput(words.join(' '));
                  }}
                >
                  ×
                </button>
              </div>
            ))}
          </div>
          
          <div className="dictionary-word-selector">
            <h4>Available Dictionary Words</h4>
            <div className="dictionary-words-grid">
              {Array.isArray(dictionary) ? (
                dictionary.map((entry, index) => (
                  <button 
                    key={index} 
                    className="dictionary-word-btn"
                    onClick={() => {
                      // Add the word to the description
                      const currentWords = descriptionInput.trim() ? descriptionInput.split(' ') : [];
                      currentWords.push(entry.word);
                      setDescriptionInput(currentWords.join(' '));
                    }}
                  >
                    {entry.word}
                  </button>
                ))
              ) : (
                // Handle old dictionary format (object)
                Object.entries(dictionary).map(([word, data], index) => (
                  <button 
                    key={index} 
                    className="dictionary-word-btn"
                    onClick={() => {
                      // Add the word to the description
                      const currentWords = descriptionInput.trim() ? descriptionInput.split(' ') : [];
                      currentWords.push(word);
                      setDescriptionInput(currentWords.join(' '));
                    }}
                  >
                    {word}
                  </button>
                ))
              )}
            </div>
          </div>
          
          {validationError && <p className="validation-error">{validationError}</p>}
          <button 
            className="submit-description-btn"
            onClick={handleSubmitDescription}
            disabled={!descriptionInput.trim()}
            ref={descriptionInputRef}
          >
            Submit Description
          </button>
        </div>
      </div>
    </div>
  );
};

export default WordDescription; 